module.exports = __webpack_public_path__ + "img/Tarifrechner_Bild_neu_vonERGO_Teaser-SBUCalculator2020_small.3ab67b48.jpg";